







































import { Component, Vue } from 'vue-property-decorator';
import CircleButton from '@/components/CircleButton.vue';
import Modal from '@/components/Modal.vue';

import pageContent from '@/contents/symposium';

@Component({
  components: {
    CircleButton,
    Modal,
  },
})
export default class Scientific extends Vue {
  public modalOpen = '';

  public pageContent = pageContent;

  close(id: string) {
    this.modalOpen = this.modalOpen === id ? '' : id;
  }

  open(link: string) {
    window.open(link, '_blank');
  }
}

